// extracted by mini-css-extract-plugin
export default {"modalOverlay":"bJ-z","modalContent":"cJ-z","header":"dJ-z","close":"eJ-z"};